import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Velikost in razmerje",
  "description": "",
  "published": "2007-04-04T00:00:00.000Z",
  "redirect_from": ["/blog/velikost-in-razmerje/swizec/242"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`VÄeraj mi je sodelavec podal povezavo do `}<a parentName="p" {...{
        "href": "http://typetester.maratz.com/"
      }}>{`typetesterja`}</a>{` - orodja, ki bi ga moral vsak spletni designer uporabljati pri svojem delu. OmogoÄa namreÄ preizkušanje razliÄnih pisav pri razliÄnih velikostih in barvah in, povrhu vsega, še lepo izgleda, kar je za uporabna orodja velika redkost.`}</p>
    <p>{`Skozi `}<a parentName="p" {...{
        "href": "http://www.commissionedcomic.com/"
      }}>{`commissioned`}</a>{` oz. njih blog, sem odkril `}<a parentName="p" {...{
        "href": "http://www.nikon.co.jp/main/eng/feelnikon/discovery/universcale/index_f.htm"
      }}>{`tole lepo stvarco`}</a>{`, ki namerava postaviti vse od najveÄjega do najmanjšega v razmerje. Razvijalec bi moral malce bolj pomisliti na uporabnike, ker se zadeva premika moÄno prepoÄasi, hkrati pa se med prikazom zanimivosti ne neha premikati zaradi Äesar se marsikaj spregleda.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      